import {
    getGridColumnStorageKey,
    type GridColumnStorageScope,
} from './gridColumnStorage';

export type GridColumnVisibilityScope = GridColumnStorageScope;

const storagePrefix = 'grid-column-visibility';

export const getGridColumnVisibilityKey = (
    scope: GridColumnVisibilityScope
): string | undefined => getGridColumnStorageKey(storagePrefix, scope);

export const readHiddenColumnIds = (storageKey?: string): Set<number> => {
    if (!storageKey) {
        return new Set();
    }

    try {
        const storedValue = window.localStorage.getItem(storageKey);
        const parsedValue: unknown = storedValue ? JSON.parse(storedValue) : [];

        if (!Array.isArray(parsedValue)) {
            return new Set();
        }

        return new Set(
            parsedValue.filter(
                (columnId): columnId is number =>
                    typeof columnId === 'number' &&
                    Number.isInteger(columnId) &&
                    columnId > 0
            )
        );
    } catch {
        return new Set();
    }
};

export const saveHiddenColumnIds = (
    storageKey: string | undefined,
    hiddenColumnIds: ReadonlySet<number>
): void => {
    if (!storageKey) {
        return;
    }

    if (hiddenColumnIds.size === 0) {
        window.localStorage.removeItem(storageKey);
        return;
    }

    window.localStorage.setItem(
        storageKey,
        JSON.stringify([...hiddenColumnIds].sort((left, right) => left - right))
    );
};
